import { render, staticRenderFns } from "./SubscriptionCardHeader.vue?vue&type=template&id=4d963a24&"
import script from "./SubscriptionCardHeader.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports